var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprisePlanLrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1358",
    "data-name": "Group 1358",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 3,
    fill: "#8f6aea"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.511,7.8V4.5H3.375V19.341h15.89V7.8ZM6.629,17.691H5V16.04H6.629Zm0-3.3H5v-1.65H6.629Zm0-3.3H5V9.447H6.629Zm0-3.3H5V6.146H6.629Zm3.254,9.894H8.257V16.04H9.884Zm0-3.3H8.257v-1.65H9.884Zm0-3.3H8.257V9.447H9.884Zm0-3.3H8.257V6.146H9.884Zm7.754,9.894H11.511V16.04h1.627V14.394H11.511v-1.65h1.627v-1.65H11.511V9.447h6.127ZM16.2,11.1H14.575v1.65H16.2Zm0,3.3H14.575v1.65H16.2Z",
    transform: "translate(4.18 3.275)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprisePlanLrg);
export default __webpack_public_path__ + "static/media/enterprise_plan_lrg.6f06ed07b7429e5747125ac78157b2e4.svg";
export { ForwardRef as ReactComponent };